import { AnyAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { User } from '../../model/dto/userProfile/user';
import { AccountSliceState } from './accountSlice.state';
import { Auth0UserData } from '../../model/auth0/auth0UserData';
import { resetAnalytics } from '../../services/analytics';


const initialState: AccountSliceState = {
  auth0Account: undefined,
  userProfile: undefined,
  permissions: []
}

export const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    clearAccount: (state: any, _action: AnyAction) => {
      state.auth0Account = initialState.auth0Account;
      state.userProfile = initialState.userProfile;
    },

    setAuth0Account(state: any, action: PayloadAction<Auth0UserData>) {
      state.auth0Account = action.payload;
    },

    setUserProfile(state: any, action: PayloadAction<User | undefined>) {
      state.userProfile = action?.payload;
      state.permissions =
        action.payload?.currentOrganization?.members?.find((m: { user: { id: string | undefined; }; }) => m.user?.id === action.payload?.id)
          ?.permissions
          ?.map((a: { permissionId: any; }) => a.permissionId) ?? [];
    }
  },
});


export const {
  clearAccount,
  setAuth0Account,
  setUserProfile,
} = accountSlice.actions;

export const selectIsAuthenticated = (state: RootState) => !!state?.account?.auth0Account;
export const selectAuth0Account = (state: RootState) => state?.account?.auth0Account;
export const selectUserProfile = (state: RootState) => state?.account?.userProfile;
export const selectUserPermissions = (state: RootState) => state?.account?.permissions;

export const signInWithAuth0 = (redirectUrl: string, _language?: string, loginId?: string, _allowRegistration?: boolean, screenHint?: string) => {
  const auth = (window as any).laerdal?.auth;
  const provider = typeof auth?.get === 'function' ? auth.get('auth0') : auth;
  provider?.login({
    // redirectURL is gigya-only; auth0 provider passes options to loginWithRedirect, so use appState
    appState: { returnUrl: redirectUrl },
    authorizationParams: {
      login_hint: loginId || undefined,
      ...(screenHint ? { screen_hint: screenHint } : {}),
    },
  });
};

export const signOutWithAuth0 = () => {
  // Clear analytics identity before the logout redirect kills the JS context
  resetAnalytics();
  (window as any).laerdal?.auth?.logout();
};

export const selectUserWebshopMarketCode = (state: RootState) => {
  var webshopService = state?.account?.userProfile?.currentOrganization?.services?.find(x => x.name == "Webshop");
  if (webshopService) {
    return webshopService.commerceMarket?.code
  }
  return "";
};

export const selectUserWebshopMarketCountry = (state: RootState) => {
  var webshopService = state?.account?.userProfile?.currentOrganization?.services?.find(x => x.name == "Webshop");
  if (webshopService) {
    return webshopService.commerceMarket?.name
  }
  return "";
};

export default accountSlice.reducer;